import { useState } from 'react'
import { MediaDrawer } from './MediaDrawer'
import { SelectMediaDrawerProps, SelectMediaProps } from '../Types'
import { MediaFileGrid } from './MediaFileGrid'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { useUnsplashPhotos } from 'components/Design/UploadsTab/useUnsplashPhotos'
import { useDebounce } from 'hooks/useDebounce'
import { Text } from 'blaze-ui/Text/Text'
import Styles from './MediaDrawer.module.scss'
import { Input } from 'almanac-ui/TextInputField/Input'

interface StockPhotosDrawerProps extends SelectMediaDrawerProps {}

export const StockPhotosDrawer = observer((props: StockPhotosDrawerProps) => {
  const { onSelect, ...rest } = props
  const { closeDrawer } = useRootStore().drawersStore
  const [query, setQuery] = useState('')
  const debouncedQuery = useDebounce(query, 500)
  const { results, showNoResults, isLoading } = useUnsplashPhotos({ query: debouncedQuery, initialCount: 24 })

  const files = results.map((result) => ({
    id: result.regular,
    source_url: result.regular,
    mime_type: 'image/png',
    width: result.width,
    height: result.height,
    variants: [],
    title: new URL(result.regular).pathname.split('/').pop() || 'Untitled',
  }))

  const handleSelect = ({ file, needsDownload }: SelectMediaProps) => {
    onSelect({ file, needsDownload, provider: 'stockPhoto' })
    closeDrawer()
  }

  return (
    <MediaDrawer {...rest}>
      <div className={Styles.searchContainer}>
        <Input
          name="Search"
          variant="grey"
          size="lg"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search stock photos..."
          autoComplete="off"
        />
        {showNoResults && <Text variant="largeList">No results found for {query}.</Text>}
        <MediaFileGrid mediaFiles={files} onSelect={handleSelect} isLoading={isLoading} needsDownload />
      </div>
    </MediaDrawer>
  )
})
